import { render, staticRenderFns } from "./Cgsbwh.vue?vue&type=template&id=0ea0c412"
import script from "./Cgsbwh.vue?vue&type=script&lang=js"
export * from "./Cgsbwh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports